
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Table, { Row, Column } from 'components/Table'
import Code from 'components/Code'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><inlineCode parentName="h3">{`StyleSheetManager`}</inlineCode></h3>
    <p>{`A helper component for modifying how your styles are processed. For a given subtree involving styled-components, you can customize various behaviors like how the CSS runtime processor (stylis) handles styles via userland plugins and option overrides.`}</p>
    <Table head={['Props', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      <Code mdxType="Code">disableCSSOMInjection (v5+)</Code>
    </Column>
    <Column mdxType="Column">
      Switches to the slower text node-based CSS injection system for adding styles to the DOM. Useful for integrating with third party tools that haven't been upgraded to consume styles from the CSSOM APIs.
    </Column>
  </Row>
      <Row mdxType="Row">
  <Column mdxType="Column">
    <Code mdxType="Code">disableVendorPrefixes (v5+)</Code>
  </Column>
  <Column mdxType="Column">Opts the given subtree out of adding legacy CSS properties for rendered components.</Column>
      </Row>
      <Row mdxType="Row">
  <Column mdxType="Column">
    <Code mdxType="Code">sheet</Code>
  </Column>
  <Column mdxType="Column">
    <em>Thar be dragons ahead.</em> Create and provide your own StyleSheet if necessary for advanced SSR scenarios.
  </Column>
      </Row>
      <Row mdxType="Row">
  <Column mdxType="Column">
    <Code mdxType="Code">stylisPlugins (v5+)</Code>
  </Column>
  <Column mdxType="Column">
    An array of plugins to be run by stylis during compilation. Check out{' '}
    <a href="https://www.npmjs.com/search?q=keywords%3Astylis" target="_blank">
      what's available on npm
    </a>
    .
  </Column>
      </Row>
  <Row mdxType="Row">
    <Column mdxType="Column">
      <Code mdxType="Code">target</Code>
    </Column>
    <Column mdxType="Column">
      <em>Thar be dragons ahead.</em> Provide an alternate DOM node to inject styles info.
    </Column>
  </Row>
    </Table>
    <p>{`For example if your app runs only in modern browsers, you may want to disable vendor prefixing for your styles:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// import styled, { StyleSheetManager } from 'styled-components'

const Box = styled.div\`
  color: \${props => props.theme.color};
  display: flex;
\`

render(
  <StyleSheetManager disableVendorPrefixes>
    <Box>If you inspect me, there are no vendor prefixes for the flexbox style.</Box>
  </StyleSheetManager>
)
`}</code></pre>
    <p>{`Another example would be enabling right-to-left translation for your styles via the userland `}<inlineCode parentName="p">{`stylis-plugin-rtl`}</inlineCode>{` plugin:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// import styled, { StyleSheetManager } from 'styled-components'
// import stylisRTLPlugin from 'stylis-plugin-rtl';

const Box = styled.div\`
  background: mediumseagreen;
  border-left: 10px solid red;
\`

render(
  <StyleSheetManager stylisPlugins={[stylisRTLPlugin]}>
    <Box>My border is now on the right!</Box>
  </StyleSheetManager>
)
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;